<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择区域"
        v-model="searchData.areaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input-number
        controls-position="right"
        size="small"
        class="mr-10px !w-50 mb-10px"
        :min="1"
        v-model="searchData.inspectionCycle"
        placeholder="请选择排查周期"
        :precision="0"
        clearable
      ></el-input-number>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查周期单位"
        v-model="searchData.unitCycle"
        clearable
      >
        <el-option
          v-for="item in unitCycleList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.inspectionType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查类型"
        clearable
      >
        <el-option
          v-for="item in checkTypeList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
      <el-button
        class="mb-10px"
        size="small"
        :disabled="!$hasAccess('create')"
        @click="handleEvent(null, 'create')"
        >批量设置任务</el-button
      >
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
        @selection-change="handleSelection"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="设备设施名称"
          width="180"
          prop="deviceName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="设备设施编号"
          width="120"
          prop="deviceCode"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="所属区域" prop="areaName" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="检查项目"
          prop="inspectionItems"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查内容"
          prop="troubleshootingContent"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="排查周期" prop="inspectionCycle" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.inspectionCycle }}{{ unitCycleListMap(scope.row.unitCycle) }}
          </template>
        </el-table-column>
        <el-table-column label="排查类型" prop="inspectionType" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ checkTypeListMap(scope.row.inspectionType) }}
          </template>
        </el-table-column>
        <el-table-column
          label="初次排查时间"
          prop="initialInvestigationTime"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            {{
              scope.row.initialInvestigationTime &&
                dayjs(scope.row.initialInvestigationTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="排查截至时间"
          prop="deadlineForTime"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            {{
              scope.row.deadlineForTime &&
                dayjs(scope.row.deadlineForTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="排查人"
          prop="deadlinePersonName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="计划状态"
          width="180"
          fixed="right"
          prop="planStatus"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.planStatus"
              :active-value="true"
              :inactive-value="false"
              active-text="启用"
              inactive-text="停用"
              @change="(value) => changeValues(value, scope.$index, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <!-- 设备计划表单 -->
    <timing-equip-form
      v-if="formDialog"
      :formProps="formProps"
      :formData="formData"
      @refreshList="
        formDialog = false
        findList()
      "
      @cancel="formDialog = false"
    ></timing-equip-form>

    <!-- 计划分配 -->
    <el-dialog
      v-if="dialogShow"
      :close-on-click-modal="false"
      title="新增"
      :visible.sync="dialogShow"
      class="small-dialog"
      v-dialogDrag
    >
      <task-unit-config
        ref="taskUnitAdd"
        oper="batch"
        :currentRow="selectionData"
        :columns="24"
        @cancel="dialogShow = false"
      ></task-unit-config>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="save()">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { HiddenDangerScheduledTaskApi } from '@wiz-api/double-prevention-management'
import { AreaApi } from '@wiz-api/area-management'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import utils from '@/components/safety/enumField/utils'
import TimingEquipForm from './TimingEquipForm'
import TaskUnitConfig from '../TimingTask/TaskUnitConfig'

const areaApi = new AreaApi()
const hiddenDangerScheduledTaskApi = new HiddenDangerScheduledTaskApi()

export default {
  name: 'timing-equip-table',
  components: {
    TableOperateButton,
    TimingEquipForm,
    TaskUnitConfig,
  },
  data() {
    return {
      // 当前行信息
      currentRow: null,
      unitCycleList: [],
      checkTypeList: [],
      dialogShow: false,
      pageNo: 1,
      pageSize: 15,
      formProps: {
        editType: 'create',
        visible: true,
      },
      value: '',
      formDialog: false,
      formData: {},
      areaList: [],
      accidentTypeList: [],
      selectionData: [],
      // 设备设施清单
      tableData: [],
      loading: false,
      total: 0,
      searchData: {
        keywords: '',
        unitCycle: null,
        areaId: undefined,
        inspectionCycle: undefined,
        inspectionType: null,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update') && val.planStatus === false,
          },
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
        ]
      }
    },
    // 排查周期
    unitCycleListMap() {
      return (val) => {
        return (
          this.unitCycleList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkTypeListMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  created() {
    this.searchList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
      ],
      ['unitCycleList', 'checkTypeList'],
      this
    )
    this.getAreaList()
  },
  methods: {
    // 启用/停用 0 设备设施 1 作业活动 2基础管理
    changeValues(value, index, row) {
      if (!row.initialInvestigationTime || !row.deadlineForTime) {
        this.$message({
          showClose: true,
          message: '该任务不存在排查时间，不可操作',
          type: 'warning',
        })
        return
      }
      this.$confirm(`是否${value === true ? '启用' : '停用'}任务`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await hiddenDangerScheduledTaskApi.startOrClose({
            body: {
              id: row.id,
              checklistTypeEnums: 0,
              isStart: value,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            this.searchList()
          }
        })
        .catch(() => {
          this.tableData[index].planStatus = !value
        })
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      switch (operation) {
        case 'create':
          if (!this.selectionData || this.selectionData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选记录',
              type: 'warning',
            })
            return
          }
          this.dialogShow = true
          break
        case 'update':
          if (row.planStatus === true) {
            this.$message({
              showClose: true,
              message: '请先停用任务，在进行编辑',
              type: 'warning',
            })
            return
          }
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'delete':
          this.$confirm('是否确定删除', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            const [err, res] = await hiddenDangerScheduledTaskApi.deleteRegularEquipmentInspection({
              id: row.id,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              })
              this.searchList()
            }
          })

          break
        default:
          break
      }
    },
    // 多选
    handleSelection(values) {
      this.selectionData = values
    },
    // 保存
    async save() {
      if (this.$refs.taskUnitAdd.submitForm()) {
        const [err, res] = await hiddenDangerScheduledTaskApi.updateRegularEquipmentInspection({
          body: this.$refs.taskUnitAdd.handleSaveData(),
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: '保存设置成功',
            type: 'success',
          })
          this.dialogShow = false
          this.searchList()
        }
      }
    },
    // 取消
    cancel() {
      this.dialogShow = false
    },
    // 弹窗初始化操作
    initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      if (row) {
        const rowData = JSON.parse(JSON.stringify(row))
        this.$set(this, 'formData', rowData)
      } else {
        this.formData = this.$options.data().formData
      }
      this.formDialog = true
    },
    // 搜索 equip 设备设施 job 作业活动
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    // 设备设施列表
    async findList() {
      this.loading = true
      this.searchData.inspectionCycle =
        this.searchData.inspectionCycle && String(this.searchData.inspectionCycle)
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await hiddenDangerScheduledTaskApi.getRegularEquipmentInspectionListAsnyc(
        data
      )
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style></style>
